import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { Link } from 'react-router-dom';

var animCSS = '\n\
@keyframes sg-fade-up {\n\
  from { opacity: 0; transform: translateY(24px); }\n\
  to { opacity: 1; transform: translateY(0); }\n\
}\n\
@keyframes sg-scale-in {\n\
  from { opacity: 0; transform: scale(0.85); }\n\
  to { opacity: 1; transform: scale(1); }\n\
}\n\
.sg-hidden { opacity: 0; }\n\
.sg-fade-up { animation: sg-fade-up 0.6s ease-out forwards; }\n\
.sg-scale-in { animation: sg-scale-in 0.5s ease-out forwards; }\n\
.sg-stagger-1 { animation-delay: 0s; }\n\
.sg-stagger-2 { animation-delay: 0.12s; }\n\
.sg-stagger-3 { animation-delay: 0.24s; }\n\
.sg-stagger-4 { animation-delay: 0.36s; }\n\
.sg-stagger-5 { animation-delay: 0.48s; }\n\
';

class ShippingGuide extends Component {
  constructor(props) {
    super(props);
    this._observer = null;
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this._setupObserver();
  }

  componentWillUnmount() {
    if (this._observer) {
      this._observer.disconnect();
    }
  }

  _setupObserver() {
    if (typeof IntersectionObserver === 'undefined') {
      var els = document.querySelectorAll('.sg-hidden');
      for (var i = 0; i < els.length; i++) {
        els[i].classList.remove('sg-hidden');
      }
      return;
    }

    var obs;
    obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var el = entry.target;
            var anim = el.getAttribute('data-anim') || 'sg-fade-up';
            el.classList.add(anim);
            obs.unobserve(el);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -20px 0px' }
    );
    this._observer = obs;

    var self = this;
    setTimeout(function () {
      var els = document.querySelectorAll('.sg-hidden');
      for (var i = 0; i < els.length; i++) {
        self._observer.observe(els[i]);
      }
    }, 50);
  }

  render() {
    function StepCard(props) {
      var staggerClass = ' sg-stagger-' + props.step;
      return React.createElement('div', {
        className: 'sg-hidden tw-flex-1 tw-min-w-[220px] tw-max-w-[280px] tw-bg-white dark:tw-bg-[#141414] tw-rounded-2xl tw-border tw-border-[#e8e8e8] dark:tw-border-[#2a2a2a] tw-p-5 tw-text-center' + staggerClass,
        style: { boxShadow: '0 2px 12px rgba(0,0,0,0.04)' },
        'data-anim': 'sg-fade-up',
      },
        React.createElement('div', {
          className: 'tw-w-12 tw-h-12 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-mx-auto tw-mb-3 tw-text-xl',
          style: { backgroundColor: props.iconBg || 'rgba(201,168,76,0.1)', color: props.iconColor || '#c9a84c' },
        }, React.createElement('i', { className: 'fa fa-' + props.icon })),
        React.createElement('div', {
          className: 'tw-text-xs tw-font-bold tw-uppercase tw-tracking-wider tw-mb-1',
          style: { color: '#c9a84c' },
        }, 'Step ' + props.step),
        React.createElement('h3', {
          className: 'tw-text-sm tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white tw-mb-2',
        }, props.title),
        React.createElement('p', {
          className: 'tw-text-xs tw-text-[#888] dark:tw-text-gray-500 tw-leading-relaxed tw-mb-0',
        }, props.text)
      );
    }

    function InfoCard(props) {
      var staggerClass = props.stagger ? ' sg-stagger-' + props.stagger : '';
      return React.createElement('div', {
        className: 'sg-hidden tw-bg-white dark:tw-bg-[#141414] tw-rounded-2xl tw-border tw-border-[#e8e8e8] dark:tw-border-[#2a2a2a] tw-p-6' + staggerClass,
        style: { boxShadow: '0 2px 12px rgba(0,0,0,0.04)' },
        'data-anim': 'sg-fade-up',
      },
        React.createElement('div', {
          className: 'tw-flex tw-items-center tw-gap-3 tw-mb-3',
        },
          React.createElement('div', {
            className: 'tw-w-10 tw-h-10 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-lg tw-flex-shrink-0',
            style: { backgroundColor: props.iconBg || 'rgba(201,168,76,0.1)', color: props.iconColor || '#c9a84c' },
          }, React.createElement('i', { className: 'fa fa-' + props.icon })),
          React.createElement('h3', {
            className: 'tw-text-base tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white tw-mt-0 tw-mb-0',
          }, props.title)
        ),
        React.createElement('div', {
          className: 'tw-text-sm tw-text-[#666] dark:tw-text-gray-400 tw-leading-relaxed',
        }, props.children)
      );
    }

    return (
      <div className="tw-min-h-screen">
        <style>{animCSS}</style>
        <Helmet>
          <title>Shipping Guide | Primal Marketplace</title>
          <meta name="description" content="Learn how to package and ship trading cards safely on Primal Marketplace. Covers supplies, shipping methods, tracking requirements, and tips." />
          <meta property="og:title" content="Shipping Guide | Primal Marketplace" />
          <meta property="og:description" content="Everything you need to know about shipping cards on Primal Marketplace." />
        </Helmet>

        {/* Hero */}
        <div className="tw-text-center tw-pt-10 tw-pb-8 tw-px-4 tw-max-w-2xl tw-mx-auto" style={{ animation: 'sg-fade-up 0.6s ease-out both' }}>
          <h1 className="tw-text-3xl md:tw-text-4xl tw-font-extrabold tw-text-[#1a1a1a] dark:tw-text-white tw-mb-4 tw-leading-tight">
            Shipping Guidelines
          </h1>
          <p className="tw-text-lg tw-text-[#666] dark:tw-text-gray-400 tw-leading-relaxed tw-mb-0">
            How to package and ship trading cards safely so they arrive in perfect condition.
          </p>
        </div>

        {/* Packaging Your Cards */}
        <div className="tw-max-w-4xl tw-mx-auto tw-px-4 tw-py-10">
          <div className="sg-hidden tw-text-center tw-mb-8" data-anim="sg-fade-up">
            <span className="tw-text-xs tw-font-bold tw-uppercase tw-tracking-widest tw-text-brand-gold tw-mb-2 tw-block">Step by Step</span>
            <h2 className="tw-text-2xl tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white">
              Packaging Your Cards
            </h2>
          </div>
          <div className="tw-flex tw-gap-4 tw-flex-wrap tw-justify-center">
            <StepCard
              step="1"
              icon="shield"
              title="Penny Sleeve"
              text="Slide the card into a standard penny sleeve. This protects the surface from scratches and keeps it clean."
            />
            <StepCard
              step="2"
              icon="id-card"
              title="Toploader or Cardboard"
              text="Place the sleeved card into a toploader or between two pieces of rigid cardboard. This prevents bending during transit."
            />
            <StepCard
              step="3"
              icon="shopping-bag"
              title="Team Bag or Plastic Bag"
              text="Seal the toploader in a team bag or small sandwich bag to protect against moisture during shipping."
            />
            <StepCard
              step="4"
              icon="envelope"
              title="Envelope or Mailer"
              text="Place in a plain white envelope (PWE) for budget shipments or a bubble mailer for tracked shipments."
            />
          </div>
        </div>

        {/* Divider */}
        <div className="tw-max-w-4xl tw-mx-auto tw-px-4">
          <div className="tw-border-t tw-border-[#e8e8e8] dark:tw-border-[#2a2a2a]" />
        </div>

        {/* Shipping Methods */}
        <div className="tw-max-w-3xl tw-mx-auto tw-px-4 tw-py-10">
          <div className="sg-hidden tw-text-center tw-mb-8" data-anim="sg-fade-up">
            <span className="tw-text-xs tw-font-bold tw-uppercase tw-tracking-widest tw-text-brand-gold tw-mb-2 tw-block">Methods</span>
            <h2 className="tw-text-2xl tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white tw-mb-3">
              Shipping Methods
            </h2>
            <p className="tw-text-sm tw-text-[#888] dark:tw-text-gray-500 tw-max-w-lg tw-mx-auto">
              Shipping is handled automatically. Orders $10 and above ship free. Smaller orders have a flat $1.00 shipping fee — buyers pay it once per seller. Tracking is required for orders $50 and above.
            </p>
          </div>

          <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4">
            <InfoCard icon="envelope" title="Standard (PWE)" stagger="1" iconBg="rgba(59,130,246,0.1)" iconColor="#3b82f6">
              <p className="tw-mb-2"><strong className="tw-text-[#1a1a1a] dark:tw-text-white">For orders under $50 (optional)</strong></p>
              <ul className="tw-list-none tw-p-0 tw-m-0 tw-flex tw-flex-col tw-gap-1.5 tw-text-sm">
                <li><i className="fa fa-check tw-text-xs tw-mr-2" style={{ color: '#16a34a' }} />Plain white envelope with stamp</li>
                <li><i className="fa fa-check tw-text-xs tw-mr-2" style={{ color: '#16a34a' }} />Cost: ~$0.78 (Forever stamp)</li>
                <li><i className="fa fa-check tw-text-xs tw-mr-2" style={{ color: '#16a34a' }} />Delivery: 5-9 business days</li>
                <li><i className="fa fa-exclamation-triangle tw-text-xs tw-mr-2" style={{ color: '#f59e0b' }} />No tracking — buyer pays $1.00 shipping under $10</li>
              </ul>
            </InfoCard>

            <InfoCard icon="truck" title="Tracked (Bubble Mailer)" stagger="2" iconBg="rgba(22,163,74,0.1)" iconColor="#16a34a">
              <p className="tw-mb-2"><strong className="tw-text-[#1a1a1a] dark:tw-text-white">Required for orders $50+</strong></p>
              <ul className="tw-list-none tw-p-0 tw-m-0 tw-flex tw-flex-col tw-gap-1.5 tw-text-sm">
                <li><i className="fa fa-check tw-text-xs tw-mr-2" style={{ color: '#16a34a' }} />Bubble mailer with tracking</li>
                <li><i className="fa fa-check tw-text-xs tw-mr-2" style={{ color: '#16a34a' }} />USPS Ground Advantage (~$4)</li>
                <li><i className="fa fa-check tw-text-xs tw-mr-2" style={{ color: '#16a34a' }} />Delivery: 3-5 business days</li>
                <li><i className="fa fa-check tw-text-xs tw-mr-2" style={{ color: '#16a34a' }} />Full tracking protection</li>
              </ul>
            </InfoCard>
          </div>
        </div>

        {/* Divider */}
        <div className="tw-max-w-4xl tw-mx-auto tw-px-4">
          <div className="tw-border-t tw-border-[#e8e8e8] dark:tw-border-[#2a2a2a]" />
        </div>

        {/* When Tracking is Required */}
        <div className="tw-max-w-3xl tw-mx-auto tw-px-4 tw-py-10">
          <div className="sg-hidden tw-text-center tw-mb-8" data-anim="sg-fade-up">
            <span className="tw-text-xs tw-font-bold tw-uppercase tw-tracking-widest tw-text-brand-gold tw-mb-2 tw-block">Requirements</span>
            <h2 className="tw-text-2xl tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white tw-mb-3">
              When Tracking is Required
            </h2>
          </div>

          <div className="sg-hidden tw-bg-white dark:tw-bg-[#141414] tw-rounded-2xl tw-border tw-border-[#e8e8e8] dark:tw-border-[#2a2a2a] tw-p-6 tw-mb-4" style={{ boxShadow: '0 2px 12px rgba(0,0,0,0.04)' }} data-anim="sg-fade-up">
            <div className="tw-flex tw-flex-col tw-gap-4">
              <div className="tw-flex tw-items-start tw-gap-3">
                <div className="tw-w-8 tw-h-8 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-flex-shrink-0 tw-text-sm" style={{ backgroundColor: 'rgba(22,163,74,0.1)', color: '#16a34a' }}>
                  <i className="fa fa-check" />
                </div>
                <div>
                  <p className="tw-text-sm tw-font-semibold tw-text-[#1a1a1a] dark:tw-text-white tw-mb-1">Orders $50 and above</p>
                  <p className="tw-text-sm tw-text-[#666] dark:tw-text-gray-400 tw-mb-0">
                    Must ship with tracking. Use a bubble mailer with USPS Ground Advantage or similar tracked service. Tracking protects both you and the buyer.
                  </p>
                </div>
              </div>
              <div className="tw-border-t tw-border-[#e8e8e8] dark:tw-border-[#2a2a2a]" />
              <div className="tw-flex tw-items-start tw-gap-3">
                <div className="tw-w-8 tw-h-8 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-flex-shrink-0 tw-text-sm" style={{ backgroundColor: 'rgba(59,130,246,0.1)', color: '#3b82f6' }}>
                  <i className="fa fa-envelope" />
                </div>
                <div>
                  <p className="tw-text-sm tw-font-semibold tw-text-[#1a1a1a] dark:tw-text-white tw-mb-1">Orders under $50</p>
                  <p className="tw-text-sm tw-text-[#666] dark:tw-text-gray-400 tw-mb-0">
                    Can ship without tracking (PWE). The buyer has the option to pay a tracking upgrade fee ($5.50) at checkout. If no tracking is purchased, the seller assumes dispute risk on that order.
                  </p>
                </div>
              </div>
              <div className="tw-border-t tw-border-[#e8e8e8] dark:tw-border-[#2a2a2a]" />
              <div className="tw-flex tw-items-start tw-gap-3">
                <div className="tw-w-8 tw-h-8 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-flex-shrink-0 tw-text-sm" style={{ backgroundColor: 'rgba(245,158,11,0.1)', color: '#f59e0b' }}>
                  <i className="fa fa-exclamation-triangle" />
                </div>
                <div>
                  <p className="tw-text-sm tw-font-semibold tw-text-[#1a1a1a] dark:tw-text-white tw-mb-1">Dispute Risk</p>
                  <p className="tw-text-sm tw-text-[#666] dark:tw-text-gray-400 tw-mb-0">
                    On orders without tracking, if a buyer opens a dispute claiming they didn't receive the item, the seller has no proof of delivery. We strongly recommend using tracked shipping whenever possible.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="tw-max-w-4xl tw-mx-auto tw-px-4">
          <div className="tw-border-t tw-border-[#e8e8e8] dark:tw-border-[#2a2a2a]" />
        </div>

        {/* Tips */}
        <div className="tw-max-w-3xl tw-mx-auto tw-px-4 tw-py-10">
          <div className="sg-hidden tw-text-center tw-mb-8" data-anim="sg-fade-up">
            <span className="tw-text-xs tw-font-bold tw-uppercase tw-tracking-widest tw-text-brand-gold tw-mb-2 tw-block">Pro Tips</span>
            <h2 className="tw-text-2xl tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white">
              Shipping Tips
            </h2>
          </div>

          <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4">
            <InfoCard icon="pencil" title='Write "Non-Machinable"' stagger="1">
              <p className="tw-mb-0">
                Write "Non-Machinable" on PWE envelopes. This prevents USPS sorting machines from bending your cards. You may need an extra $0.40 surcharge stamp.
              </p>
            </InfoCard>
            <InfoCard icon="sticky-note" title="Use Painter's Tape" stagger="2">
              <p className="tw-mb-0">
                Tape the opening of the toploader shut with painter's tape (not packing tape). This keeps the card from sliding out without leaving sticky residue.
              </p>
            </InfoCard>
            <InfoCard icon="ban" title="Don't Over-Sleeve" stagger="3">
              <p className="tw-mb-0">
                One penny sleeve is enough. Double-sleeving can cause the card to bow or bend inside the toploader. Keep it simple.
              </p>
            </InfoCard>
            <InfoCard icon="dropbox" title="Bubble Mailers" stagger="4" iconBg="rgba(59,130,246,0.1)" iconColor="#3b82f6">
              <p className="tw-mb-0">
                For tracked orders, use a small bubble mailer (4x8 or 6x9). Place the toploader in the center with extra cardboard if needed. Don't forget to add the tracking number on Primal Market after shipping.
              </p>
            </InfoCard>
          </div>
        </div>

        {/* Divider */}
        <div className="tw-max-w-4xl tw-mx-auto tw-px-4">
          <div className="tw-border-t tw-border-[#e8e8e8] dark:tw-border-[#2a2a2a]" />
        </div>

        {/* Supplies You'll Need */}
        <div className="tw-max-w-3xl tw-mx-auto tw-px-4 tw-py-10">
          <div className="sg-hidden tw-text-center tw-mb-8" data-anim="sg-fade-up">
            <span className="tw-text-xs tw-font-bold tw-uppercase tw-tracking-widest tw-text-brand-gold tw-mb-2 tw-block">Checklist</span>
            <h2 className="tw-text-2xl tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white tw-mb-3">
              Supplies You'll Need
            </h2>
            <p className="tw-text-sm tw-text-[#888] dark:tw-text-gray-500 tw-max-w-lg tw-mx-auto">
              Stock up on these essentials before your first sale. Most can be found at your local dollar store or ordered online in bulk.
            </p>
          </div>

          <div className="sg-hidden tw-bg-white dark:tw-bg-[#141414] tw-rounded-2xl tw-border tw-border-[#e8e8e8] dark:tw-border-[#2a2a2a] tw-p-6" style={{ boxShadow: '0 2px 12px rgba(0,0,0,0.04)' }} data-anim="sg-fade-up">
            <div className="tw-flex tw-flex-col tw-gap-3">
              {[
                { name: 'Penny Sleeves (100 pack)', cost: '~$1-2', icon: 'shield' },
                { name: 'Toploaders (25 pack)', cost: '~$5-8', icon: 'id-card' },
                { name: 'Team Bags (100 pack)', cost: '~$3-5', icon: 'shopping-bag' },
                { name: 'Bubble Mailers (25 pack)', cost: '~$8-12', icon: 'envelope' },
                { name: "Painter's Tape", cost: '~$3-5', icon: 'sticky-note' },
                { name: 'Forever Stamps (book of 20)', cost: '~$14', icon: 'ticket' },
              ].map(function(item, i) {
                return React.createElement('div', {
                  key: i,
                  className: 'tw-flex tw-items-center tw-gap-3 tw-py-2' + (i < 5 ? ' tw-border-b tw-border-[#e8e8e8] dark:tw-border-[#2a2a2a]' : ''),
                },
                  React.createElement('div', {
                    className: 'tw-w-8 tw-h-8 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-flex-shrink-0 tw-text-sm',
                    style: { backgroundColor: 'rgba(201,168,76,0.1)', color: '#c9a84c' },
                  }, React.createElement('i', { className: 'fa fa-' + item.icon })),
                  React.createElement('span', {
                    className: 'tw-text-sm tw-text-[#1a1a1a] dark:tw-text-white tw-flex-1',
                  }, item.name),
                  React.createElement('span', {
                    className: 'tw-text-sm tw-font-semibold tw-text-[#666] dark:tw-text-gray-400',
                  }, item.cost)
                );
              })}
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="tw-max-w-4xl tw-mx-auto tw-px-4">
          <div className="tw-border-t tw-border-[#e8e8e8] dark:tw-border-[#2a2a2a]" />
        </div>

        {/* Multiple Card Orders */}
        <div className="tw-max-w-3xl tw-mx-auto tw-px-4 tw-py-10">
          <div className="sg-hidden tw-text-center tw-mb-8" data-anim="sg-fade-up">
            <span className="tw-text-xs tw-font-bold tw-uppercase tw-tracking-widest tw-text-brand-gold tw-mb-2 tw-block">Multi-Card</span>
            <h2 className="tw-text-2xl tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white tw-mb-3">
              Multiple Card Orders
            </h2>
            <p className="tw-text-sm tw-text-[#888] dark:tw-text-gray-500 tw-max-w-lg tw-mx-auto">
              Buyers only pay shipping once per seller. Here's how to package multiple cards together safely.
            </p>
          </div>

          <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-4">
            <InfoCard icon="clone" title="Sleeve Each Card" stagger="1">
              <p className="tw-mb-0">
                Put each card in its own penny sleeve and toploader. Never stack unsleeved cards — they'll scratch each other.
              </p>
            </InfoCard>
            <InfoCard icon="sort-amount-asc" title="Stack Together" stagger="2">
              <p className="tw-mb-0">
                Stack toploaders face-to-face, wrap with a rubber band, and place the stack in a team bag. This keeps everything secure.
              </p>
            </InfoCard>
            <InfoCard icon="cube" title="Pack in Mailer" stagger="3">
              <p className="tw-mb-0">
                Place the bundle in a bubble mailer. For 5+ cards, add extra cardboard on each side for additional rigidity.
              </p>
            </InfoCard>
          </div>
        </div>

        {/* Divider */}
        <div className="tw-max-w-4xl tw-mx-auto tw-px-4">
          <div className="tw-border-t tw-border-[#e8e8e8] dark:tw-border-[#2a2a2a]" />
        </div>

        {/* Common Mistakes */}
        <div className="tw-max-w-3xl tw-mx-auto tw-px-4 tw-py-10">
          <div className="sg-hidden tw-text-center tw-mb-8" data-anim="sg-fade-up">
            <span className="tw-text-xs tw-font-bold tw-uppercase tw-tracking-widest tw-text-brand-gold tw-mb-2 tw-block">Avoid These</span>
            <h2 className="tw-text-2xl tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white tw-mb-3">
              Common Mistakes
            </h2>
          </div>

          <div className="sg-hidden tw-bg-white dark:tw-bg-[#141414] tw-rounded-2xl tw-border tw-border-[#e8e8e8] dark:tw-border-[#2a2a2a] tw-p-6" style={{ boxShadow: '0 2px 12px rgba(0,0,0,0.04)' }} data-anim="sg-fade-up">
            <div className="tw-flex tw-flex-col tw-gap-4">
              {[
                {
                  title: 'Packing tape on toploaders',
                  desc: 'Packing tape leaves sticky residue on the toploader and can damage the card when removed. Use painter\'s tape instead.',
                },
                {
                  title: 'PWE without "Non-Machinable"',
                  desc: 'USPS sorting machines can bend cards inside plain envelopes. Write "Non-Machinable" on the front to route it for hand-sorting.',
                },
                {
                  title: 'Card loose in mailer',
                  desc: 'A toploader sliding around in a bubble mailer can get damaged. Secure it with tape or cardboard so it doesn\'t move.',
                },
                {
                  title: 'Forgetting to add tracking',
                  desc: 'After shipping, enter your tracking number on Primal Marketplace. Without it, your payout may be delayed and you have no proof of shipment.',
                },
              ].map(function(item, i) {
                return React.createElement('div', {
                  key: i,
                  className: 'tw-flex tw-items-start tw-gap-3' + (i < 3 ? ' tw-pb-4 tw-border-b tw-border-[#e8e8e8] dark:tw-border-[#2a2a2a]' : ''),
                },
                  React.createElement('div', {
                    className: 'tw-w-8 tw-h-8 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-flex-shrink-0 tw-text-sm',
                    style: { backgroundColor: 'rgba(239,68,68,0.1)', color: '#ef4444' },
                  }, React.createElement('i', { className: 'fa fa-times' })),
                  React.createElement('div', null,
                    React.createElement('p', {
                      className: 'tw-text-sm tw-font-semibold tw-text-[#1a1a1a] dark:tw-text-white tw-mb-1',
                    }, item.title),
                    React.createElement('p', {
                      className: 'tw-text-sm tw-text-[#666] dark:tw-text-gray-400 tw-mb-0',
                    }, item.desc)
                  )
                );
              })}
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="tw-max-w-4xl tw-mx-auto tw-px-4">
          <div className="tw-border-t tw-border-[#e8e8e8] dark:tw-border-[#2a2a2a]" />
        </div>

        {/* Shipping Timeline */}
        <div className="tw-max-w-3xl tw-mx-auto tw-px-4 tw-py-10">
          <div className="sg-hidden tw-text-center tw-mb-8" data-anim="sg-fade-up">
            <span className="tw-text-xs tw-font-bold tw-uppercase tw-tracking-widest tw-text-brand-gold tw-mb-2 tw-block">Timeline</span>
            <h2 className="tw-text-2xl tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white tw-mb-3">
              Shipping Timeline
            </h2>
            <p className="tw-text-sm tw-text-[#888] dark:tw-text-gray-500 tw-max-w-lg tw-mx-auto">
              What to expect after making a sale on Primal Marketplace.
            </p>
          </div>

          <div className="sg-hidden tw-bg-white dark:tw-bg-[#141414] tw-rounded-2xl tw-border tw-border-[#e8e8e8] dark:tw-border-[#2a2a2a] tw-p-6" style={{ boxShadow: '0 2px 12px rgba(0,0,0,0.04)' }} data-anim="sg-fade-up">
            <div className="tw-flex tw-flex-col tw-gap-0">
              {[
                {
                  day: 'Day 1-3',
                  title: 'Ship Your Order',
                  desc: 'Package and ship within 3 business days of the sale. The sooner you ship, the better your seller reputation.',
                  icon: 'paper-plane',
                  color: '#c9a84c',
                  colorBg: 'rgba(201,168,76,0.1)',
                },
                {
                  day: 'Day 1-3',
                  title: 'Enter Tracking Number',
                  desc: 'Go to your order history, click the order, and enter the tracking number. This starts the 14-day buyer protection window.',
                  icon: 'barcode',
                  color: '#3b82f6',
                  colorBg: 'rgba(59,130,246,0.1)',
                },
                {
                  day: 'Day 3-10',
                  title: 'Buyer Receives Order',
                  desc: 'The buyer can confirm receipt at any time. If they do, your payout is released immediately.',
                  icon: 'inbox',
                  color: '#16a34a',
                  colorBg: 'rgba(22,163,74,0.1)',
                },
                {
                  day: 'Day 14+',
                  title: 'Auto-Release Payout',
                  desc: 'If the buyer doesn\'t confirm or open a dispute within 14 days of shipping, your payout is automatically released.',
                  icon: 'money',
                  color: '#16a34a',
                  colorBg: 'rgba(22,163,74,0.1)',
                },
              ].map(function(item, i) {
                return React.createElement('div', {
                  key: i,
                  className: 'tw-flex tw-items-start tw-gap-4 tw-py-4' + (i < 3 ? ' tw-border-b tw-border-[#e8e8e8] dark:tw-border-[#2a2a2a]' : ''),
                },
                  React.createElement('div', {
                    className: 'tw-flex tw-flex-col tw-items-center tw-flex-shrink-0',
                    style: { width: '48px' },
                  },
                    React.createElement('div', {
                      className: 'tw-w-10 tw-h-10 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-sm',
                      style: { backgroundColor: item.colorBg, color: item.color },
                    }, React.createElement('i', { className: 'fa fa-' + item.icon }))
                  ),
                  React.createElement('div', { className: 'tw-flex-1' },
                    React.createElement('span', {
                      className: 'tw-text-[10px] tw-font-bold tw-uppercase tw-tracking-wider tw-text-[#999] dark:tw-text-gray-600',
                    }, item.day),
                    React.createElement('p', {
                      className: 'tw-text-sm tw-font-semibold tw-text-[#1a1a1a] dark:tw-text-white tw-mb-1',
                    }, item.title),
                    React.createElement('p', {
                      className: 'tw-text-sm tw-text-[#666] dark:tw-text-gray-400 tw-mb-0',
                    }, item.desc)
                  )
                );
              })}
            </div>
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="sg-hidden tw-text-center tw-py-12 tw-px-4" data-anim="sg-fade-up">
          <h2 className="tw-text-2xl tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white tw-mb-3">
            Ready to sell?
          </h2>
          <p className="tw-text-sm tw-text-[#888] dark:tw-text-gray-500 tw-mb-6">
            Set your price and shipping cost. Buyers pay shipping once per seller — multiple items ship together.
          </p>
          <Link
            to="/sell"
            className="tw-inline-block tw-bg-brand-gold hover:tw-bg-brand-gold-dark tw-text-black tw-font-bold tw-py-3 tw-px-10 tw-rounded-lg tw-text-sm tw-no-underline tw-transition-colors"
          >
            Start Selling
          </Link>
        </div>

        {/* Footer */}
        <div className="tw-text-center tw-py-6 tw-border-t tw-border-[#e8e8e8] dark:tw-border-[#2a2a2a]">
          <Link to="/" className="tw-text-xs tw-text-[#999] dark:tw-text-gray-600 tw-no-underline tw-mr-5 hover:tw-text-brand-gold tw-transition-colors">
            Primal Marketplace
          </Link>
          <Link to="/more" className="tw-text-xs tw-text-[#999] dark:tw-text-gray-600 tw-no-underline tw-mr-5 hover:tw-text-brand-gold tw-transition-colors">
            How It Works
          </Link>
          <Link to="/terms" className="tw-text-xs tw-text-[#999] dark:tw-text-gray-600 tw-no-underline hover:tw-text-brand-gold tw-transition-colors">
            Terms
          </Link>
        </div>
      </div>
    );
  }
}

export default ShippingGuide;
